import { EuiAvatar, EuiBadge, EuiContextMenu, EuiFlexGroup, EuiFlexItem, EuiHeaderLink, EuiHeaderSectionItemButton, EuiIconTip, EuiPopover, EuiToolTip } from '@elastic/eui';
import React, { useMemo } from 'react';
//import { useProfile } from '../../../../shared/hooks/Profile';

//const _Style = {padding: "8px",backgroundColor:"darkred"}

export const SelectorPerfil = (props) =>{

    const {profile, rol} = props;

    // const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    // const onPopoverClick = () => setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
    // const closePopover = () => setIsPopoverOpen(false);

    //useEffect(()=> {if(selected!==undefined){setIsPopoverOpen(false)}},[selected])

    // const getItems = useMemo(()=>[{
    //     id: 0,
    //     items: [ {
    //             key: `link-profile-user`,
    //             //name: <p>{'Perfil'}</p>,
    //             icon: (<EuiIconTip
    //             content={'perfil info'}
    //             position={"down"}
    //             ><EuiAvatar color="#ff7e62" size="m" type="user" name={profile === 'RRH' ? 'RH' : profile} initialsLength={2}/></EuiIconTip>)
                
    //             //<EuiAvatar color="#ff7e62" size="m" type="user" name={p.value === 'RRH' ? 'RH' : p.value} initialsLength={2}/>
    //         }
    //     ]
    // }],[profile])

    // const button = useCallback(() => selected && (
    //     <EuiHeaderSectionItemButton
    //       aria-expanded={isPopoverOpen}
    //       aria-haspopup="true"
    //       onClick={onPopoverClick}
    //       >
    //       <EuiHeaderLink key={'headerlink-profile'} className="profileButtonMenu" title={selected.label}>
    //       {/* key={'headerlink-languege'} className="languageButtonMenu" */}
    //         <EuiFlexGroup gutterSize='s' title={selected.label}>
    //             <EuiFlexItem grow={false} title={selected.label}>
    //                 <EuiAvatar title={selected.label} color="#ff7e62" size="m" type="user" name={selected.value === 'RRH' ? 'RH' : selected.value} initialsLength={2}/>
    //             </EuiFlexItem>
    //             {/* <EuiFlexItem>{selected.label}</EuiFlexItem> */}
    //         </EuiFlexGroup>
    //       </EuiHeaderLink>
    //     </EuiHeaderSectionItemButton>
    // )
    // ,[isPopoverOpen,onPopoverClick,selected])

    // return(
    //     <EuiPopover
    //     key={'popover-profile-selection'}
	// 	ownFocus={false}
	// 	anchorPosition='downCenter'
	// 	button={button()}
	// 	isOpen={isPopoverOpen}
	// 	closePopover={closePopover}
    //     panelStyle={_panelStyle}
    //     panelClassName="popover-user-profile-selection"
	// 	initialFocus="[id=popover-profile-selection]">
    //         <EuiContextMenu initialPanelId={0} panels={getItems}/>
    //     </EuiPopover>
    // )

    const getRolInfo = useMemo(()=> rol!==undefined ? 
        (<EuiFlexItem className='rol-info'>
            <p style={{color:'linen', fontSize:'smaller', textAlign:'center', width:'110px'}}>{rol}</p>
        </EuiFlexItem>)
        :null
    ,[rol])

    const getProfile = useMemo(()=>
    <EuiFlexGroup alignItems='center'>
        <EuiFlexItem className='profile-info' grow={false}><EuiAvatar title={undefined} color="#ff7e62" size="m" type="user" name={profile.value === 'RRH' ? 'RH' : profile.value} initialsLength={2}/></EuiFlexItem>
        {/* {getRolInfo} */}
    </EuiFlexGroup>
    ,[profile,rol])

    return(
        <EuiFlexGroup>
            <EuiFlexItem className='menu-profile-info'>
                <EuiToolTip
                    content={profile.label}
                    position={"bottom"}
                >
                {getProfile}
                </EuiToolTip>
            </EuiFlexItem>
        </EuiFlexGroup>
    )
        
}